import { render, staticRenderFns } from "./ToppingDetail.vue?vue&type=template&id=66003bef"
import script from "./ToppingDetail.vue?vue&type=script&lang=js"
export * from "./ToppingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports